import React, { createContext, useContext, useState, useEffect } from 'react';

const MovieContext = createContext();

export const useMovieContext = () => useContext(MovieContext);

export const MovieProvider = ({ children }) => {
  const [movies, setMovies] = useState([]);
  const [watchLaterList, setWatchLaterList] = useState([]);  // New state for watch later list

  const [latestMovies, setLatestMovies] = useState([]);
  const [trendingMovies, setTrendingMovies] = useState([]);
  const [topRatedMovies, setTopRatedMovies] = useState([]);
  const [upcomingMovies, setUpcomingMovies] = useState([]);
  const [tvShows, setTvShows] = useState([]);
  const [selectedMovieId, setSelectedMovieId] = useState(null);
  const [videos, setVideos] = useState([]);
  const [error, setError] = useState(null);
  

  useEffect(() => {
    fetchMovies();
    fetchLatestMovies();
    fetchTrendingMovies();
    fetchTopRatedMovies();
    fetchUpcomingMovies();
    fetchTvShows();
  }, []);

  useEffect(() => {
    if (selectedMovieId) {
      fetchMovieVideos(selectedMovieId);
    }
  }, [selectedMovieId]);

  const fetchMovies = async () => {
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3NDY1NzM0ZjNlM2IxMDk0MTEzNjRjMzRlNGI1MDAyYyIsInN1YiI6IjY2NDRhNmZiNGVjNjY1ODBkMGVlYTMyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.BApYsoZnnAmhTEgS_h022LArcrQw9hvP6hdA-Bw9mdQ'
      }
    };

    try {
      const response = await fetch('https://api.themoviedb.org/3/movie/now_playing?language=en-US&page=1', options);
      const data = await response.json();
      setMovies(data.results);
    } catch (error) {
      setError(error.message || 'An error occurred while fetching movies');
    }
  };

  const fetchLatestMovies = async () => {
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3NDY1NzM0ZjNlM2IxMDk0MTEzNjRjMzRlNGI1MDAyYyIsInN1YiI6IjY2NDRhNmZiNGVjNjY1ODBkMGVlYTMyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.BApYsoZnnAmhTEgS_h022LArcrQw9hvP6hdA-Bw9mdQ'
      }
    };

    try {
      const response = await fetch('https://api.themoviedb.org/3/movie/now_playing?language=en-US&page=1', options);
      const data = await response.json();
      setLatestMovies(data.results);
    } catch (error) {
      setError(error.message || 'An error occurred while fetching latest movies');
    }
  };

  const fetchTrendingMovies = async () => {
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3NDY1NzM0ZjNlM2IxMDk0MTEzNjRjMzRlNGI1MDAyYyIsInN1YiI6IjY2NDRhNmZiNGVjNjY1ODBkMGVlYTMyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.BApYsoZnnAmhTEgS_h022LArcrQw9hvP6hdA-Bw9mdQ'
      }
    };

    try {
      const response = await fetch('https://api.themoviedb.org/3/trending/movie/day?language=en-US&page=2', options);
      const data = await response.json();
      setTrendingMovies(data.results);
    } catch (error) {
      setError(error.message || 'An error occurred while fetching trending movies');
    }
  };

  const fetchTopRatedMovies = async () => {
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3NDY1NzM0ZjNlM2IxMDk0MTEzNjRjMzRlNGI1MDAyYyIsInN1YiI6IjY2NDRhNmZiNGVjNjY1ODBkMGVlYTMyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.BApYsoZnnAmhTEgS_h022LArcrQw9hvP6hdA-Bw9mdQ'
      }
    };

    try {
      const response = await fetch('https://api.themoviedb.org/3/movie/top_rated?language=en-US&page=1', options);
      const data = await response.json();
      setTopRatedMovies(data.results);
    } catch (error) {
      setError(error.message || 'An error occurred while fetching top-rated movies');
    }
  };

  const fetchUpcomingMovies = async () => {
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3NDY1NzM0ZjNlM2IxMDk0MTEzNjRjMzRlNGI1MDAyYyIsInN1YiI6IjY2NDRhNmZiNGVjNjY1ODBkMGVlYTMyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.BApYsoZnnAmhTEgS_h022LArcrQw9hvP6hdA-Bw9mdQ'
      }
    };

    try {
      const response = await fetch('https://api.themoviedb.org/3/movie/upcoming?language=en-US&page=1', options);
      const data = await response.json();
      setUpcomingMovies(data.results);
    } catch (error) {
      setError(error.message || 'An error occurred while fetching upcoming movies');
    }
  };

  const fetchTvShows = async () => {
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3NDY1NzM0ZjNlM2IxMDk0MTEzNjRjMzRlNGI1MDAyYyIsInN1YiI6IjY2NDRhNmZiNGVjNjY1ODBkMGVlYTMyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.BApYsoZnnAmhTEgS_h022LArcrQw9hvP6hdA-Bw9mdQ'
      }
    };

    try {
      const response = await fetch('https://api.themoviedb.org/3/tv/on_the_air?language=en-US&page=1', options);
      const data = await response.json();
      setTvShows(data.results);
    } catch (error) {
      setError(error.message || 'An error occurred while fetching TV shows');
    }
  };

  const fetchMovieVideos = async (movieId) => {
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3NDY1NzM0ZjNlM2IxMDk0MTEzNjRjMzRlNGI1MDAyYyIsInN1YiI6IjY2NDRhNmZiNGVjNjY1ODBkMGVlYTMyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.BApYsoZnnAmhTEgS_h022LArcrQw9hvP6hdA-Bw9mdQ'
      }
    };

    try {
      const response = await fetch(`https://api.themoviedb.org/3/movie/${movieId}/videos?language=en-US`, options);
      const data = await response.json();
      setVideos(data.results);
    } catch (error) {
      setError(error.message || 'An error occurred while fetching videos');
    }
  };

  const handleSelectMovie = (movieId) => {
    setSelectedMovieId(movieId);
  };
  const addToWatchLater = (movie) => {
    setWatchLaterList((prevList) => {
      if (!prevList.find((m) => m.id === movie.id)) {
        return [...prevList, movie];
      }
      return prevList;
    });
  };

  return (
    <MovieContext.Provider value={{ 
      movies, latestMovies, trendingMovies, topRatedMovies, 
      upcomingMovies, tvShows, selectedMovieId, videos, error, 
      handleSelectMovie, fetchMovies, watchLaterList, addToWatchLater
     }}>
      {children}
    </MovieContext.Provider>
  );
};



























































// import React, { createContext, useContext, useState, useEffect } from 'react';

// const MovieContext = createContext();

// export const useMovieContext = () => useContext(MovieContext);

// export const MovieProvider = ({ children }) => {
//   const [movies, setMovies] = useState([]);
//   const [tvShows, setTvShows] = useState([]);
//   const [selectedMovieId, setSelectedMovieId] = useState(null);
//   const [videos, setVideos] = useState([]);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     fetchMovies();
//     fetchTvShows();
//   }, []);

//   useEffect(() => {
//     if (selectedMovieId) {
//       fetchMovieVideos(selectedMovieId);
//     }
//   }, [selectedMovieId]);

//   const fetchMovies = async () => {
//     const options = {
//       method: 'GET',
//       headers: {
//         accept: 'application/json',
//         Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3NDY1NzM0ZjNlM2IxMDk0MTEzNjRjMzRlNGI1MDAyYyIsInN1YiI6IjY2NDRhNmZiNGVjNjY1ODBkMGVlYTMyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.BApYsoZnnAmhTEgS_h022LArcrQw9hvP6hdA-Bw9mdQ'
//       }
//     };

//     try {
//       const response = await fetch('https://api.themoviedb.org/3/movie/now_playing?language=en-US&page=1', options);
//       const data = await response.json();
//       setMovies(data.results);
//     } catch (error) {
//       setError(error.message || 'An error occurred while fetching movies');
//     }
//   };

//   const fetchTvShows = async () => {
//     const options = {
//       method: 'GET',
//       headers: {
//         accept: 'application/json',
//         Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3NDY1NzM0ZjNlM2IxMDk0MTEzNjRjMzRlNGI1MDAyYyIsInN1YiI6IjY2NDRhNmZiNGVjNjY1ODBkMGVlYTMyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.BApYsoZnnAmhTEgS_h022LArcrQw9hvP6hdA-Bw9mdQ'
//       }
//     };

//     try {
//       const response = await fetch('https://api.themoviedb.org/3/tv/on_the_air?language=en-US&page=1', options);
//       const data = await response.json();
//       setTvShows(data.results);
//     } catch (error) {
//       setError(error.message || 'An error occurred while fetching TV shows');
//     }
//   };

//   const fetchMovieVideos = async (movieId) => {
//     const options = {
//       method: 'GET',
//       headers: {
//         accept: 'application/json',
//         Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3NDY1NzM0ZjNlM2IxMDk0MTEzNjRjMzRlNGI1MDAyYyIsInN1YiI6IjY2NDRhNmZiNGVjNjY1ODBkMGVlYTMyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.BApYsoZnnAmhTEgS_h022LArcrQw9hvP6hdA-Bw9mdQ'
//       }
//     };

//     try {
//       const response = await fetch(`https://api.themoviedb.org/3/movie/${movieId}/videos?language=en-US`, options);
//       const data = await response.json();
//       setVideos(data.results);
//     } catch (error) {
//       setError(error.message || 'An error occurred while fetching videos');
//     }
//   };

//   const handleSelectMovie = (movieId) => {
//     setSelectedMovieId(movieId);
//   };

//   return (
//     <MovieContext.Provider value={{ movies, tvShows, selectedMovieId, videos, error, handleSelectMovie, fetchMovies }}>
//       {children}
//     </MovieContext.Provider>
//   );
// };









































































// // src/context/MovieContext.js
// import React, { createContext, useState, useContext, useEffect } from 'react';

// const MovieContext = createContext();

// export const useMovieContext = () => useContext(MovieContext);

// export const MovieProvider = ({ children }) => {
//   const [movies, setMovies] = useState([]);
//   const [selectedMovieId, setSelectedMovieId] = useState(null);
//   const [videos, setVideos] = useState([]);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const options = {
//       method: 'GET',
//       headers: {
//         accept: 'application/json',
//         Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3NDY1NzM0ZjNlM2IxMDk0MTEzNjRjMzRlNGI1MDAyYyIsInN1YiI6IjY2NDRhNmZiNGVjNjY1ODBkMGVlYTMyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.BApYsoZnnAmhTEgS_h022LArcrQw9hvP6hdA-Bw9mdQ'
//       }
//     };

//     fetch('https://api.themoviedb.org/3/movie/now_playing?language=en-US&page=1', options)
//       .then(response => {
//         if (!response.ok) {
//           throw new Error('Network response was not ok');
//         }
//         return response.json();
//       })
//       .then(data => {
//         setMovies(data.results);
//       })
//       .catch(error => {
//         console.error('There was a problem with your fetch operation:', error);
//         setError(error.message || 'An error occurred while fetching data');
//       });
//   }, []);

//   useEffect(() => {
//     if (!selectedMovieId) return;

//     const options = {
//       method: 'GET',
//       headers: {
//         accept: 'application/json',
//         Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3NDY1NzM0ZjNlM2IxMDk0MTEzNjRjMzRlNGI1MDAyYyIsInN1YiI6IjY2NDRhNmZiNGVjNjY1ODBkMGVlYTMyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.BApYsoZnnAmhTEgS_h022LArcrQw9hvP6hdA-Bw9mdQ'
//       }
//     };

//     fetch(`https://api.themoviedb.org/3/movie/${selectedMovieId}/videos?language=en-US`, options)
//       .then(response => {
//         if (!response.ok) {
//           throw new Error('Network response was not ok');
//         }
//         return response.json();
//       })
//       .then(data => {
//         setVideos(data.results);
//       })
//       .catch(error => {
//         console.error('There was a problem with your fetch operation:', error);
//         setError(error.message || 'An error occurred while fetching data');
//       });
//   }, [selectedMovieId]);

//   const handleSelectMovie = (movieId) => {
//     setSelectedMovieId(movieId);
//   };

//   return (
//     <MovieContext.Provider value={{ movies, selectedMovieId, videos, error, handleSelectMovie }}>
//       {children}
//     </MovieContext.Provider>
//   );
// };

// export default MovieContext;

















































// // src/context/MovieContext.js
// import React, { createContext, useState, useContext } from 'react';

// const MovieContext = createContext();

// export const useMovieContext = () => useContext(MovieContext);

// export const MovieProvider = ({ children }) => {
//   const [selectedMovieId, setSelectedMovieId] = useState(null);

//   const handleSelectMovie = (movieId) => {
//     setSelectedMovieId(movieId);
//   };

//   return (
//     <MovieContext.Provider value={{ selectedMovieId, handleSelectMovie }}>
//       {children}
//     </MovieContext.Provider>
//   );
// };

// export default MovieContext;
